<template>
	<div class="template_box">
		<div class="content_box">
			<div class="Activity_content_box">
				<div class="Activity_content" v-for="(item, index) in three_guarantees_list" :key="item.id">
					<div class="after_sale_title">{{ item.after_sale_title }}</div>
					<div class="after_sale_subtitle">{{ item.after_sale_subtitle }}</div>
					<div class="A_text" v-for="(obj, nn) in item.text_obj" :key="obj.id">
						<span class="obj_text">{{ obj.text }}</span>
						
						<el-table ref="multipleTable" v-if="obj.type == 'fault'" :data="obj.table" :cell-style="cellStyle" :header-cell-style="headerrow" border stripe highlight-current-row class="el-table">
							<el-table-column label="服务类型" :width="width" align="center">
							  <template slot-scope="{ row }">
							    <span>{{ row.title}}</span>
							  </template>
							</el-table-column>
							<el-table-column label="服务政策" align="center">
							  <template slot-scope="{ row }">
							    <span>{{ row.text}}</span>
							  </template>
							</el-table-column>
						</el-table>
						
						<el-table ref="multipleTable" v-if="obj.type == 'guarantee'" :data="obj.table" :cell-style="cellStyle" :header-cell-style="headerrow" border stripe highlight-current-row class="el-table">
							<el-table-column label="服务类型" :width="width" align="center">
							  <template slot-scope="{ row }">
							    <span>{{ row.title}}</span>
							  </template>
							</el-table-column>
							<el-table-column label="服务政策" align="center">
							  <template slot-scope="{ row }">
							    <span>{{ row.text}}</span>
							  </template>
							</el-table-column>
							<el-table-column label="服务方式" align="center">
							  <template slot-scope="{ row }">
							    <span>{{ row.way}}</span>
							  </template>
							</el-table-column>
						</el-table>
						
						
					</div>
				</div>
			</div>
			
			<div class="Activity_content_box">
				<div class="Activity_content margin_top" v-for="(item, index) in problem_list" :key="item.id">
					<div class="A_title">{{ item.title }}</div>
					<div class="A_text" v-for="(obj, nn) in item.text_obj" :key="obj.id">
						<span class="obj_text">{{ obj.text }}</span>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
	name: 'After_saleService',
   data() {
		return {
			width: 80,
			// 三包
			three_guarantees_list:[
				{
					after_sale_title:'TOZO产品三包政策',
					after_sale_subtitle:'售后服务严格依据《中华人民共和国消费者权益法》、《中华人民共和国产品质量法》实行售后三包服务，服务内容如下：',
					text_obj:[
						{
							id:0,
							text:'在三包有效期内，依照本规定免费享受退货、换货、维修的服务，换货、退货、维修应当凭发票/购买订单办理。',
						},
						{
							id:1,
							text:'1、7天无理由退货（电商购买渠道），15天包换（品质问题）。非质量问题的退货运费由消费者承担，再次发货运费由商家承担。如有发票和赠品，需一并寄回。7天无理由退货必须保证退回的产品不影响二次销售。',
						},
						{
							id:2,
							text:'2、如客户在线下门店购买，可以委托代理商进行退换货服务，当然也支持消费者寻找品牌方进行售后。',
						},
						{
							id:3,
							text:'3、产品在正常使用条件下出现性能故障的情况，经检测确定后，可以免费享受如下服务：',
							type:'fault',
							table:[
								{
									id:0,
									title:'退货',
									text:'自签收日次日起7天内产品质量原因退货（电商渠道7天无理由退货）',
								},
								{
									id:1,
									title:'换货',
									text:'自签收日次日起15天内产品质量原因换货',
								},
								{
									id:2,
									title:'维修',
									text:'自签收日次日起1年内产品质量原因维修',
								},
							]
						},
						{
							id:4,
							text:'4、客户购买的产品，可以按照下列售后服务承诺事件表享受保修服务：',
							type:'guarantee',
							table:[
								{
									id:0,
									title:'音频类&移动电源充电类',
									text:'自购买日起12个月内产品质量原因',
									way:'寄修/送修',
								},
								{
									id:1,
									title:'充电线类',
									text:'自购买日起3个月内产品质量原因',
									way:'寄修/送修',
								},
								{
									id:2,
									title:'耗材类',
									text:'无质保期',
									way:'寄修/送修',
								},
							]
						},
					],
				}
			],
			// 问题
			problem_list:[
				// 不属于
				{
					id:1,
					title: '不属于保修范围的问题',
					text_obj:[
						{
							id:1,
							text:'1、非本公司产品或从非官方授权渠道购买的产品；',
						},
						{
							id:2,
							text:'2、经过第三方维修或改装过的产品；',
						},
						{
							id:3,
							text:'3、明显由于客户使用不当造成的损坏，如：妄用、碰撞、跌落、事故、改动、浸液、挤压等；',
						},
						{
							id:4,
							text:'4、被撕毁、涂改标贴、防伪标记等的产品；',
						},
						{
							id:5,
							text:'5、已超过三包有效期后出现的问题；',
						},
						{
							id:6,
							text:'6、不当存储造成的损坏，如产品长时间暴露在非正常湿度、温度环境中造成的性能损坏；',
						},
						{
							id:7,
							text:'7、产品的自然磨损和老化问题，如外观损坏（磨损、刮花等）；',
						},
						{
							id:8,
							text:'8、使用第三方充电设备充电造成的产品损坏；',
						},
						{
							id:9,
							text:'9、产品丢失或被盗。',
						}
					]
				},
				// 其它说明
				{
					id:2,
					title: '其它说明',
					text_obj:[
						{
							id:1,
							text:'1、在经营活动中赠送的TOZO产品，不享受三包的退货政策，可享受对应产品出现异常的换货和保修政策。',
						},
						{
							id:2,
							text:'2、官方经营活动赠送的非TOZO品牌产品，由相应的品牌售后跟进其服务，终端线下门店赠送的非TOZO品牌产品，由线下门店与用户协调提供换货或者维修服务。',
						}
					]
				}
			],
		}
   },
	computed: {
		headerrow() {
	      return {
	        'border-color': '#999999', // 修改边框颜色
	        'color': '#000000' ,// 修改字体颜色
			  'font-size': '14px',
	      };
	   },
	},
	
   mounted(){
		this.updateScreenWidth()
		// 监听窗口大小变化，以便在窗口大小改变时更新 screenWidth
		window.addEventListener('resize', this.updateScreenWidth);
   },
	
	beforeDestroy() {
	   // 组件销毁前移除事件监听
	   window.removeEventListener('resize', this.updateScreenWidth);
	},
	
	methods: {
		updateScreenWidth(){
			var screenWidth = window.innerWidth;
			var width_num = screenWidth / 4
			if(width_num > 200){
				this.width = 200
			}else if(width_num < 50){
				this.width = 50
			}else{
				this.width = width_num
			}
		},
		cellStyle({row, column, rowIndex, columnIndex}) {
			let weight;
			if (columnIndex == 0 || columnIndex == 2) {
				weight = 700
			}else{
				weight = 500
			}
			return {
				'font-weight': weight,
				'border-color': '#999999', // 修改边框颜色
				'color': '#000000' ,// 修改字体颜色
				'font-size': '12px',
			}
		},
   }
}
</script>

<style lang='less' scoped>
.template_box{
	background-color: #fff;
}
.content_box{
	background-color: #fff;
	font-family: PingFang SC-Medium, PingFang SC;
	text-align: left;
	padding-bottom: 20px;
}
.margin_top{
	margin-top: 12px;
}
.el-table{
	width: 100%;
	margin: 15px 0px;
	border: 1px solid #999999;
}
.Activity_content_box{
	.Activity_content{
		width: 100%;
		font-family: PingFang SC-Medium, PingFang SC;
		.after_sale_title{
			margin-top: 26px;
			height: 28px;
			font-size: 16px;
			font-weight: 600;
			color: #000000;
			text-align: center;
		}
		.after_sale_subtitle{
			margin-top: 12px;
			line-height: 22px;
			font-size: 14px;
			font-weight: 600;
			color: #000000;
			text-align: c;
		}
		.A_title{
			margin-top: 20px;
			text-align: center;
			font-size: 14px;
			font-weight: 600;
			color: #000000;
			line-height: 22px;
		}
		.A_text{
			margin-top: 5px;
			font-size: 12px;
			font-weight: 400;
			color: #000000;
			line-height: 20px;
		}
	}
}
</style>
